
import { Doctor } from '../types';
import { doctors as mockDoctors } from '../data/mockData';

// Helper functions for mock data in localStorage

/**
 * Get mock doctors data from localStorage or default to initial mock data
 */
export const getMockDoctors = (): Doctor[] => {
  const storedData = localStorage.getItem('mock_doctors');
  return storedData ? JSON.parse(storedData) : mockDoctors || [];
};

/**
 * Save mock doctors data to localStorage
 */
export const saveMockDoctors = (doctors: Doctor[]): void => {
  localStorage.setItem('mock_doctors', JSON.stringify(doctors));
};

/**
 * Reset mock doctors data in localStorage
 */
export const resetMockDoctors = (): void => {
  localStorage.removeItem('mock_doctors');
};

/**
 * Check if mock data is allowed based on env variable and environment
 */
export const useMockData = (): boolean => {
  // Never use mock data in production
  if (import.meta.env.PROD) {
    return false;
  }
  
  // In development, check env var - default to false if not set
  const mockDataSetting = import.meta.env.VITE_USE_MOCK_DATA;
  return mockDataSetting === 'true';
};

/**
 * Create a mock file upload function for development
 */
export const handleMockFileUpload = (formData: FormData): string => {
  // Mock image URL with a random identifier
  const randomId = Math.floor(Math.random() * 1000000);
  return `https://picsum.photos/id/${randomId}/200`;
};

/**
 * Ensure all required doctor fields have values
 */
export const ensureDoctorDefaults = (doctor: Partial<Doctor>): Doctor => {
  return {
    ...doctor as Doctor,
    weeklyOffDays: doctor.weeklyOffDays || [],
    slotDuration: doctor.slotDuration || 30,
    startTime: doctor.startTime || "09:00",
    endTime: doctor.endTime || "17:00"
  };
};
